module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topbar"
  }, [_c('nav', {
    staticClass: "navbar-custom"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "list-inline menu-left mb-0"
  }, [_vm._m(2), _vm._v(" "), _c('li', {
    staticClass: "hide-phone list-inline-item app-search"
  }, [_c('h3', {
    staticClass: "page-title",
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.page_title))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-wrap",
    attrs: {
      "id": "search-wrap"
    }
  }, [_c('div', {
    staticClass: "search-bar"
  }, [_c('input', {
    staticClass: "search-input",
    attrs: {
      "type": "search",
      "placeholder": "Search"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "close-search toggle-search",
    attrs: {
      "href": "#",
      "data-target": "#search-wrap"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-close-circle"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list-inline float-right mb-0"
  }, [_c('li', {
    staticClass: "list-inline-item dropdown notification-list"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle arrow-none waves-effect",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#",
      "role": "button",
      "aria-haspopup": "false",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "ion-ios7-bell noti-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "badge badge-danger noti-icon-badge"
  }, [_vm._v("3")])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right dropdown-arrow dropdown-menu-lg"
  }, [_c('div', {
    staticClass: "dropdown-item noti-title"
  }, [_c('h5', [_vm._v("Notification (3)")])]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item notify-item active",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('div', {
    staticClass: "notify-icon bg-success"
  }, [_c('i', {
    staticClass: "mdi mdi-cart-outline"
  })]), _vm._v(" "), _c('p', {
    staticClass: "notify-details"
  }, [_c('b', [_vm._v(" order is placed")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Dummy text of the printing and typesetting industry.")])])]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item notify-item",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('div', {
    staticClass: "notify-icon bg-warning"
  }, [_c('i', {
    staticClass: "mdi mdi-message"
  })]), _vm._v(" "), _c('p', {
    staticClass: "notify-details"
  }, [_c('b', [_vm._v("New Message received")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("You have 87 unread messages")])])]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item notify-item",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('div', {
    staticClass: "notify-icon bg-info"
  }, [_c('i', {
    staticClass: "mdi mdi-martini"
  })]), _vm._v(" "), _c('p', {
    staticClass: "notify-details"
  }, [_c('b', [_vm._v("item is shipped")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("It is a long established fact that a reader will")])])]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item notify-item",
    attrs: {
      "href": "/notifications"
    }
  }, [_vm._v("\r\n                            View All\r\n                        ")])])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item dropdown notification-list"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle arrow-none waves-effect nav-user",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#",
      "role": "button",
      "aria-haspopup": "false",
      "aria-expanded": "false"
    }
  }, [_c('img', {
    staticClass: "rounded-circle",
    attrs: {
      "src": "/static/assets/images/users/avatar-1.jpg",
      "alt": "user"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right profile-dropdown "
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "/account"
    }
  }, [_c('i', {
    staticClass: "dripicons-user text-muted"
  }), _vm._v(" Profile")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "/payments"
    }
  }, [_c('i', {
    staticClass: "dripicons-wallet text-muted"
  }), _vm._v(" Payments")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "/settings"
    }
  }, [_c('span', {
    staticClass: "badge badge-success pull-right m-t-5"
  }, [_vm._v("5")]), _c('i', {
    staticClass: "dripicons-gear text-muted"
  }), _vm._v(" Settings")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-divider"
  }), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "dripicons-exit text-muted"
  }), _vm._v(" Logout")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "list-inline-item"
  }, [_c('button', {
    staticClass: "button-menu-mobile open-left waves-effect",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "ion-navicon"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6aeb94e6"}!./src/pages/MainHeader/template.html
// module id = 298
// module chunks = 0